import { defineTokens } from "@chakra-ui/react";

export const colors = defineTokens.colors({
  blackAlpha: {
    "0": {
      value: "#000000",
    },
    "50": {
      value: "#00000000",
    },
    "100": {
      value: "#00000000",
    },
    "200": {
      value: "#00000000",
    },
    "300": {
      value: "#00000000",
    },
    "400": {
      value: "#00000000",
    },
    "600": {
      value: "#00000000",
    },
    "700": {
      value: "#00000003",
    },
    "800": {
      value: "#00000003",
    },
    "900": {
      value: "#00000003",
    },
    "950": {
      value: "#00000003",
    },
  },
  gray: {
    "0": {
      value: "#FCFCFE",
    },
    "50": {
      value: "#F4F4F4",
    },
    "100": {
      value: "#E0E0E0",
    },
    "200": {
      value: "#E4E4E7",
    },
    "800": {
      value: "#1E1E1E",
    },
    "900": {
      value: "#292929",
    },
    "950": {
      value: "#141414",
    },
  },
  red: {
    "50": {
      value: "#FEEFED",
    },
    "70": {
      value: "#FEE2E2",
    },
  },
  redOrange: {
    "50": {
      value: "#FCE9E6",
    },
    "100": {
      value: "#FFCDBA",
    },
    "200": {
      value: "#FFAC8E",
    },
    "300": {
      value: "#FF8C60",
    },
    "400": {
      value: "#FF733C",
    },
    "500": {
      value: "#FF5A15",
    },
    "600": {
      value: "#F45510",
    },
    "700": {
      value: "#E64E0A",
    },
    "800": {
      value: "#D84706",
    },
    "900": {
      value: "#C03900",
    },
    "950": {
      value: "#220A04",
    },
  },
  whiteAlpha: {
    "0": {
      value: "#FFFFFF",
    },
    "50": {
      value: "#FFFFFF00",
    },
    "100": {
      value: "#FFFFFF00",
    },
    "200": {
      value: "#FFFFFF00",
    },
    "300": {
      value: "#FFFFFF00",
    },
    "400": {
      value: "#FFFFFF00",
    },
    "500": {
      value: "#FFFFFF00",
    },
    "600": {
      value: "#FFFFFF00",
    },
    "700": {
      value: "#FFFFFF03",
    },
    "800": {
      value: "#FFFFFF03",
    },
    "900": {
      value: "#FFFFFF03",
    },
    "950": {
      value: "#FFFFFF03",
    },
  },
  yellow: {
    "50": {
      value: "#FFEAD0",
    },
    "100": {
      value: "#FFE1AD",
    },
    "200": {
      value: "#FFD285",
    },
    "300": {
      value: "#FFC35C",
    },
    "400": {
      value: "#FF9A1F",
    },
    "500": {
      value: "#FFA50A",
    },
    "600": {
      value: "#CC8100",
    },
    "700": {
      value: "#B87400",
    },
    "800": {
      value: "#B16700",
    },
    "900": {
      value: "#A75300",
    },
  },
  yellowGreen: {
    "50": {
      value: "#F3F8E7",
    },
    "100": {
      value: "#E0EDC4",
    },
    "200": {
      value: "#CBE29E",
    },
    "300": {
      value: "#B6D676",
    },
    "400": {
      value: "#A5CE55",
    },
    "500": {
      value: "#A1D243",
    },
    "600": {
      value: "#85B52C",
    },
    "700": {
      value: "#70A122",
    },
    "800": {
      value: "#5B8D18",
    },
    "900": {
      value: "#356C01",
    },
    "950": {
      value: "#281304",
    },
  },
});
